import React from 'react';
import Moment from 'moment';
import 'moment/locale/ru';

export const DateBlock = ({ date }) => {
    const d = Moment(date);
    return (
        <div className={`date`}>
            <div className="date--day">{d.format("DD MMMM, YYYY")}</div>
            <div className="date--time">{d.format("HH:mm")}</div>
        </div>
    );
}